import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

/**
 * Digital product mode switch component
 * Skips shipping address and shipping rate requirements for digital product stores
 */
export const DigitalProductSwitch = () => {
    const { t } = useTranslation(['stores', 'common'])
    const { control } = useFormContext<{ digitalProduct: boolean }>()

    return (
        <div className="flex items-center justify-between">
            <div className="space-y-1">
                <Label>
                    {t('form.digitalProduct')}
                </Label>
                <p className="text-xs text-gray-500">
                    {t('form.digitalProductDescription')}
                </p>
            </div>
            <Controller
                name="digitalProduct"
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Switch checked={value} onCheckedChange={onChange} />
                )}
            />
        </div>
    )
}
